import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

export const UserTermsAndConditions = () => {
  return (
    <div className="p-4 space-y-3 text-sm text-[#404040] leading-6">
      <p>
        <strong>Effective Date:</strong> 01 Aug 2026
        <br />
        <strong>Last Updated:</strong> 01 Aug 2026
      </p>
      <p>
        These Terms and Conditions (&quot;Terms&quot;) govern your access to and
        use of <strong>Mumin&#39;s Mart</strong> (website, app, and related
        services) operated by <strong>Fluxart Solutions Private Limited</strong>
        .
      </p>
      <p>
        By creating an account or using the Platform, you agree to these Terms,
        our Privacy Policy, and any additional policies referenced here.
      </p>
      <h2 className="font-semibold">1. Eligibility</h2>
      <ul>
        <li>You must be legally competent to contract under Indian law.</li>
        <li>
          If you are under 18, use is allowed only under supervision of a
          parent/legal guardian.
        </li>
        <li>
          You must provide accurate and complete information during
          registration.
        </li>
      </ul>
      <h2 className="font-semibold">2. Account Registration and Security</h2>
      <ul>
        <li>
          You are responsible for account credentials and all activities under
          your account.
        </li>
        <li>You must promptly update incorrect or outdated information.</li>
        <li>
          We may require OTP/KYC verification for security, fraud prevention, or
          legal compliance.
        </li>
        <li>
          We may suspend or terminate accounts involved in fraud, abuse, or
          policy violations.
        </li>
      </ul>
      <h2 className="font-semibold">3. Platform Role</h2>
      <ul>
        <li>
          The Platform enables users to discover and purchase products/services
          listed by sellers.
        </li>
        <li>
          Unless explicitly stated, Fluxart Solutions Private Limited acts as an
          intermediary/marketplace facilitator and not the manufacturer of
          listed goods.
        </li>
        <li>
          Product descriptions, warranties, and specifications are generally
          provided by sellers.
        </li>
      </ul>
      <h2 className="font-semibold">4. Orders, Pricing, and Availability</h2>
      <ul>
        <li>
          All orders are subject to acceptance, stock availability, and
          verification.
        </li>
        <li>Prices, discounts, and offers may change without prior notice.</li>
        <li>
          We reserve the right to cancel or limit orders in case of pricing
          errors, suspected fraud, or policy breaches.
        </li>
        <li>
          Applicable taxes and shipping fees will be shown before final payment
          where feasible.
        </li>
      </ul>
      <h2 className="font-semibold">5. Payments</h2>
      <ul>
        <li>
          Payments are processed through authorized payment gateways and
          partners.
        </li>
        <li>
          You authorize us and our partners to process your payment
          instructions.
        </li>
        <li>
          Refund timelines may vary by payment method and banking partner
          processes.
        </li>
      </ul>
      <h2 className="font-semibold">6. Shipping, Delivery, and Risk</h2>
      <ul>
        <li>
          Delivery timelines are estimates and may vary due to logistics
          constraints.
        </li>
        <li>
          Risk and title transfer for goods will be governed by product-specific
          terms and applicable law.
        </li>
        <li>
          Delays caused by force majeure events are not treated as breaches.
        </li>
      </ul>
      <h2 className="font-semibold">7. Cancellations, Returns, and Refunds</h2>
      <ul>
        <li>
          Cancellations/returns/refunds are governed by our return policy and
          seller-specific conditions.
        </li>
        <li>
          Certain categories may be non-returnable for hygiene, safety, or legal
          reasons.
        </li>
        <li>
          Refunds may be adjusted for shipping, handling, or damages caused by
          misuse, where applicable.
        </li>
        <li>
          Refund may only be initiated if the ticket is raised within 24 hours
          of delivery.{" "}
        </li>
      </ul>
      <h2 className="font-semibold">8. User Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Violate any applicable law, regulation, or third-party rights.</li>
        <li>
          Post false, defamatory, obscene, hateful, or misleading content.
        </li>
        <li>
          Attempt unauthorized access, reverse engineering, scraping, or
          automated abuse.
        </li>
        <li>Interfere with Platform security, integrity, or performance.</li>
        <li>
          Use the Platform for money laundering, fraudulent transactions, or
          prohibited goods/services.
        </li>
      </ul>
      <h2 className="font-semibold">9. Intellectual Property</h2>
      <ul>
        <li>
          All Platform content, branding, software, and materials are owned by
          or licensed to Fluxart Solutions Private Limited.
        </li>
        <li>
          You receive a limited, non-transferable, revocable license to use the
          Platform for personal, lawful use.
        </li>
        <li>
          Unauthorized reproduction, distribution, or commercial exploitation is
          prohibited.
        </li>
      </ul>
      <h2 className="font-semibold">10. User Content and Reviews</h2>
      <ul>
        <li>
          By submitting reviews/content, you grant us a non-exclusive,
          worldwide, royalty-free license to host, use, display, and reproduce
          that content for Platform operations.
        </li>
        <li>
          You are responsible for ensuring your content is lawful and
          non-infringing.
        </li>
      </ul>
      <h2 className="font-semibold">11. Privacy</h2>
      <p>
        Use of personal data is governed by our Privacy Policy and applicable
        Indian law.
      </p>
      <h2 className="font-semibold">12. Third-Party Services</h2>
      <p>
        The Platform may include third-party links, tools, or services. We are
        not responsible for third-party content or independent terms.
      </p>
      <h2 className="font-semibold">13. Disclaimer of Warranties</h2>
      <p>
        To the maximum extent permitted by law, the Platform is provided on an
        &quot;as is&quot; and &quot;as available&quot; basis. We do not
        guarantee uninterrupted or error-free operation at all times.
      </p>
      <h2 className="font-semibold">14. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law:</p>
      <ul>
        <li>
          Fluxart Solutions Private Limited shall not be liable for indirect,
          incidental, special, consequential, or punitive damages.
        </li>
        <li>
          Our aggregate liability arising from or related to these Terms shall
          not exceed the amount paid by you for the relevant order/transaction
          giving rise to the claim, or INR 10,000, whichever is lower.
        </li>
      </ul>
      <p>
        Nothing in these Terms limits liabilities that cannot be excluded under
        applicable law.
      </p>
      <h2 className="font-semibold">15. Indemnity</h2>
      <p>
        You agree to indemnify and hold harmless Fluxart Solutions Private
        Limited, affiliates, and personnel against claims, losses, liabilities,
        and costs arising from your misuse of the Platform, legal violations, or
        infringement of third-party rights.
      </p>
      <h2 className="font-semibold">16. Suspension and Termination</h2>
      <p>
        We may suspend, restrict, or terminate your access immediately for
        violations, fraud risk, legal requirements, or security threats.
      </p>
      <h2 className="font-semibold">17. Grievance Redressal</h2>
      <p>For complaints, contact:</p>
      <ul>
        <li>Grievance Officer: Huzefa Cycle Wala</li>
        <li>Email: grievance@muminsmart.com</li>
        <li>
          Address: A78 Hasanji Nagar, Near Emerald Heights School, Indore -
          453331
        </li>
      </ul>
      <p>
        We will address grievances in accordance with applicable legal
        timelines.
      </p>
      <h2 className="font-semibold">18. Changes to Terms</h2>
      <p>
        We may update these Terms from time to time. Updated Terms will be
        posted on the Platform. Continued use after updates constitutes
        acceptance.
      </p>
      <h2 className="font-semibold">
        19. Governing Law and Dispute Resolution
      </h2>
      <ul>
        <li>These Terms are governed by Indian law.</li>
        <li>
          Courts at Indore, Madhya Pradesh, India shall have exclusive
          jurisdiction, subject to mandatory legal rights.
        </li>
        <li>
          We may also provide an internal dispute resolution mechanism before
          formal legal proceedings.
        </li>
      </ul>
      <h2 className="font-semibold">20. Contact</h2>
      <ul>
        <li>Email: support@muminsmart.com</li>
        <li>
          Address: A78 Hasanji Nagar, Near Emerald Heights School, Indore -
          453331
        </li>
      </ul>
    </div>
  );
};

const UserTermsAndConditionsDialog = () => {
  return (
    <Dialog>
      <DialogTrigger>
        <button type="button" className="font-semibold text-primary underline">
          Terms and Conditions
        </button>
      </DialogTrigger>

      <DialogContent className="max-w-2xl max-h-[85dvh] rounded-3xl">
        <DialogHeader>
          <DialogTitle>Terms and Conditions</DialogTitle>
        </DialogHeader>
        <div className="no-scrollbar max-h-[50vh] overflow-y-auto">
          <UserTermsAndConditions />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UserTermsAndConditionsDialog;
